/* eslint-disable prefer-rest-params */
import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'chart.js';

import { pieChartOptions } from './config';

const Pie = ({ data, shadow = false }) => {
  const chartContainer = useRef(null);
  const [, setChartInstance] = useState(null);

  useEffect(() => {
    //   console.log(chartContainer);
      if (shadow) {
        Chart.defaults.pieWithShadow = Chart.defaults.pie;
        Chart.controllers.pieWithShadow = Chart.controllers.pie.extend({
          draw(ease) {
            Chart.controllers.pie.prototype.draw.call(this, ease);
            const {
              chart: { ctx },
            } = this;
            ctx.save();
            ctx.shadowColor = 'rgba(0,0,0,0.15)';
            ctx.shadowBlur = 10;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 10;
            ctx.responsive = true;
            Chart.controllers.pie.prototype.draw.apply(this, arguments);
            ctx.restore();
          },
        });
      }
      const context = chartContainer.current.getContext('2d');
      const newChartInstance = new Chart(context, {
        type: shadow ? 'pieWithShadow' : 'pie',
        options: pieChartOptions,
        data,
      });
      setChartInstance(newChartInstance);
  }, []);

  return <canvas ref={chartContainer} />;
};

export default Pie;
